import styled from '@emotion/styled';
import { typography } from 'src/theme/typography';
import { brandPagination } from 'src/pages/Dashboard/paginationStyle';

const ListQuotesComponent = styled('div')`
    ${typography.bodyXs}
    color: var(--sand-700);

    .box-search {
        margin-bottom: 24px;
        .ant-select {
            height: 40px;
            .ant-select-selector {
                min-width: 155px;
                padding: 0 15px;
                border-color: var(--sand-400);
                box-shadow: none;
                ${typography.bodyMd}
                color: var(--sand-700);
                .ant-select-selection-item {
                    font-weight: inherit;
                    color: inherit;
                    padding-inline-end: 16px;
                }
            }
            &.ant-select-open .ant-select-selector {
                background: var(--sand-100);
            }
            .ant-select-arrow {
                inset-inline-end: 16px;
            }
        }
        .ant-input-compact-last-item {
            width: 292px;
            height: 40px;
            padding: 0 8px;
            border-color: var(--sand-400);
            ${typography.bodyXs}
            font-size: 16px;
            .ant-input {
                ${typography.bodyXs}
                font-size: 16px;
                color: var(--sand-700);
            }
            .ant-input-prefix {
                margin-inline-end: 8px;
                font-size: 16px;
            }
            .ant-input::placeholder {
                color: var(--sand-500);
            }
        }

        .ant-select.field-search
            .ant-select-selector
            .ant-select-selection-item {
            padding-inline-end: 28px;
        }

        .ant-btn-primary:disabled {
            background: var(--orange-300);
            border-color: var(--orange-300);
            color: var(--sand-100);
            opacity: 0.42;
        }
        .ant-btn-primary {
            ${typography.buttonMd}
            color: var(--sand-100);
        }
        .sort-label {
            font-size: 16px;
        }
    }

    .ant-table-wrapper .ant-table-pagination.ant-pagination {
        position: relative;
        min-height: 36px;
        align-items: center;
        margin: 24px 0 0;
        .ant-pagination-total-text {
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            font-size: 14px;
            line-height: 20px;
            color: var(--sand-700);
        }
        .ant-pagination-options {
            position: absolute;
            left: 112px;
            top: 50%;
            transform: translateY(-50%);
            margin: 0;
            .ant-select {
                height: 36px;
            }
            .ant-select .ant-select-selector {
                height: 36px;
                min-width: 69px;
                padding: 0 8px;
                align-items: center;
                border-color: var(--sand-400);
                border-radius: 6px;
                box-shadow: none;
                ${typography.bodyMd}
                color: var(--sand-700);
            }
            .ant-select-selection-item {
                line-height: 34px;
                font-weight: 500;
                padding-inline-end: 18px;
            }
            .ant-select-open .ant-select-selector {
                background: var(--sand-100);
            }
            .ant-select-open .ant-select-selection-item {
                color: var(--sand-700);
            }
            .ant-select-arrow {
                inset-inline-end: 8px;
                .anticon {
                    display: none;
                }
                &::after {
                    content: '';
                    border-left: 4px solid transparent;
                    border-right: 4px solid transparent;
                    border-top: 5px solid currentColor;
                }
            }
        }
        .ant-pagination-jump-prev,
        .ant-pagination-jump-next {
            color: var(--blue-400);
        }
        .pager-edge-group {
            display: flex;
            align-items: center;
            gap: 4px;
            .ant-pagination-item-link {
                width: 24px;
                height: 24px;
            }
        }
        .ant-pagination-prev:hover .ant-pagination-item-link,
        .ant-pagination-next:hover .ant-pagination-item-link {
            background: transparent;
        }
        .ant-pagination-prev:not(.ant-pagination-disabled)
            .ant-pagination-item-link:not(:disabled):hover,
        .ant-pagination-next:not(.ant-pagination-disabled)
            .ant-pagination-item-link:not(:disabled):hover {
            background: rgba(0, 0, 0, 0.06);
        }
    }
    ${brandPagination}

    .ant-select .ant-select-arrow {
        color: var(--sand-700);
    }

    .ant-table-wrapper {
        .ant-table {
            scrollbar-color: auto;
            .ant-table-cell-scrollbar {
                box-shadow: none;
            }
        }
        .ant-table-content {
            scrollbar-width: thin;
            scrollbar-color: #eaeaea transparent;
            scrollbar-gutter: stable;
        }
    }

    .ant-table-wrapper .ant-table.ant-table-small {
        .ant-table-thead > tr > th {
            padding: 12px 16px;
            &.quoteRefColumn {
                padding-inline: 8px;
            }
        }
        .ant-table-tbody > tr > td {
            ${typography.bodyXs}
            padding: 10px 16px;
            color: var(--sand-700);
            border-top: 2px solid transparent;
            border-bottom: 2px solid transparent;
        }
    }

    .ant-table-container {
        .ant-table-header {
            border-radius: 0px !important;

            .ant-table-selection-column .ant-table-selection {
                visibility: hidden;
                opacity: 0;
            }
        }
        .ant-table-cell {
            border-radius: 0px !important;
        }
        .ant-table-thead {
            th {
                ${typography.bodySm}
                font-weight: 700;
                color: var(--white);
                &::before {
                    display: none;
                }
            }
        }
        .highlight-row .ant-table-cell {
            background: var(--sand-100);
        }

        .ant-table-tbody > tr.ant-table-row:hover > td {
            background: var(--sand-300);
            color: var(--blue-400);
            border-top-color: var(--blue-300);
            border-bottom-color: var(--blue-300);
            &:first-of-type {
                box-shadow: inset 2px 0 0 var(--blue-300);
            }
            &:last-of-type {
                box-shadow: inset -2px 0 0 var(--blue-300);
            }
        }

        .box-action {
            .ant-btn-link {
                padding: 0;
                height: auto;
                position: relative;
                top: 3px;
                color: var(--blue-400);
            }
            .ant-btn-link:disabled {
                color: var(--blue-100);
            }
        }
    }

    .text-clear {
        color: var(--blue-400);
        cursor: pointer;
        margin-top: 10px;
    }
`;

export default ListQuotesComponent;
